export type Building = {
  id: string;
  name: string;
  hp: number[];
};

export type Spell = {
  id: string;
  damage: number[];
};

export type ZapQuake = {
  nbZaps: number;
  nbQuakes: number;
};

// prettier-ignore
export const DATA_BUILDINGS: Building[] = [
  { id: "18", name: "Cannon", hp: [300,360,420,500,600,660,730,800,880,960,1060,1160,1260,1380,1500,1620,1740,1870,2000,2150,2250] },
  { id: "16", name: "Archer Tower", hp: [380,420,460,500,540,580,630,690,750,810,890,970,1050,1130,1230,1330,1410,1510,1600,1700,1800] },
  { id: "23", name: "Mortar", hp: [400,450,500,550,600,650,700,800,950,1100,1300,1500,1700,1950,2150,2300,2450] },
  { id: "14", name: "Air Defense", hp: [800,850,900,950,1000,1050,1100,1210,1300,1400,1500,1650,1750,1850,1950] },
  { id: "24", name: "Wizard Tower", hp: [620,650,680,730,840,960,1200,1440,1600,1900,2120,2240,2500,2800,3000,3150,3300] },
  { id: "15", name: "Air Sweeper", hp: [750,800,850,900,950,1000,1050] },
  { id: "21", name: "Hidden Tesla", hp: [600,630,660,690,730,770,810,850,900,980,1100,1200,1350,1450,1550,1650] },
  { id: "17", name: "Bomb Tower", hp: [650,700,750,850,1050,1300,1600,1900,2300,2500,2700,2900] },
  { id: "25", name: "X-Bow", hp: [1500,1900,2300,2700,3100,3400,3700,4000,4200,4400,4600,4800] },
  { id: "22", name: "Inferno Tower", hp :[1500,1800,2100,2400,2700,3000,3300,3700,4000,4400,4800] },
  { id: "20", name: "Eagle Artillery", hp: [4000,4400,4800,5200,5600,5900,6200] },
  { id: "119", name: "Scattershot", hp: [3600,4200,4800,5100,5410,5600] },
  { id: "62", name: "Archer Queen", hp: [580,592,604,617,630,643,657,670,685,699,714,729,744,759,775,792,808,826,842,861,878,897,916,935,954,974,995,1016,1038,1059,1082,1104,1127,1151,1175,1200,1226,1251,1278,1304,1331,1359,1388,1417,1447,1478,1508,1540,1572,1606,1646,1688,1730,1774,1819,1865,1912,1960,2010,2060,2111,2164,2218,2274,2330,2384,2432,2476,2516,2552,2584,2616,2648,2680,2712,2740,2768,2796,2824,2852,2880,2904,2928,2952,2976,3000,3024,3048,3072,3096,3120,3144,3168,3192,3216,3240,3264,3288,3312,3336] },
  { id: "122", name: "Royal Champion", hp: [2508,2550,2593,2635,2678,2720,2763,2805,2848,2890,2933,2975,3018,3060,3103,3145,3188,3230,3273,3315,3349,3383,3417,3451,3485,3519,3553,3587,3621,3655,3681,3706,3732,3757,3783,3808,3834,3859,3885,3910,3936,3961,3987,4012,4038,4046,4090,4116,4142,4168] },
  { id: "63", name: "Grand Warden", hp: [850,868,886,904,923,942,961,982,1003,1025,1048,1072,1097,1122,1148,1173,1199,1224,1250,1275,1301,1327,1354,1381,1409,1438,1467,1497,1527,1558,1590,1622,1655,1688,1722,1757,1793,1829,1867,1904,1921,1938,1955,1972,1989,2006,2023,2040,2057,2074,2091,2108,2125,2142,2159,2176,2193,2210,2227,2244,2261,2278,2295,2312,2329,2346,2363,2380,2397,2414,2431,2448,2465,2482,2499] },
  { id: "127", name: "Builder Hut", hp: [250,1000,1300,1600,1800,1900,2000] },
  { id: "135", name: "Spell Tower", hp: [2500,2800,3100] },
  { id: "136", name: "Monolith", hp: [4747,5050,5353,5656] },
  { id: "137", name: "Multi-Archer Tower", hp:[5000,5200,5400]},
  { id: "138", name: "Ricochet Cannon", hp:[5400,5700,6000]},
  { id: "139", name: "Firespitter", hp:[4500,5000]},
  { id: "140", name: "Minion Prince", hp:[1200,1242,1284,1326,1368,1410,1452,1494,1536,1578,1620,1662,1704,1746,1788,1830,1872,1914,1956,1998,2040,2082,2124,2166,2208,2250,2292,2334,2376,2418,2460,2502,2544,2586,2628,2670,2712,2754,2796,2838,2880,2922,2964,3006,3048,3090,3132,3174,3216,3258,3300,3342,3384,3426,3468,3510,3552,3594,3636,3678,3720,3762,3804,3846,3888,3930,3972,4014,4056,4098,4161,4224,4287,4350,4413,4476,4539,4602,4665,4728,4791,4854,4917,4980,5043,5106,5169,5232,5295,5358]},
  { id: "214", name: "Multi-Gear Tower", hp:[4000,4200]},
];

// prettier-ignore
export const DATA_SPELLS: Spell[] = [
  { id: "earthquake", damage: [14.5,17,21,25,29] },
  { id: "lightning", damage: [150,180,210,240,270,320,400,480,560,600,640,680] },
];
